import React, { useEffect, useState } from 'react';
import liff from '@line/liff';
import { useForm, SubmitHandler, set } from 'react-hook-form';
import { useCookies } from 'react-cookie';
import '../css/liff.css';
import axios from 'axios';
import baseUrlLiff from '../lib/baseUrlLiff';
import LIFFInspectorPlugin from "@line/liff-inspector";
import {useNavigate} from "react-router-dom";

type GatewayInfo = {
    siteRecno: string;
    siteId: string;
};

interface EnvType {
    REACT_APP_LIFF_APP_ID: string;
    REACT_APP_LIFF_APP_ID_2: string;
    line_profile: string;
}

type LiffNotificationProps = {
    idToken?: any;
};

type Sensor = {
    "sensorRecno": number,
    "sensorId": string,
    "sensorName": string,
    "isNotify": boolean
};

type Gateway = {
    "gatewayRecno": number,
    "gatewayArea": string,
    "gatewayControlNo": string,
    "sensors": Sensor[]
};

type LiffSettingDatas = {
    "siteRecno": number,
    "siteId": string,
    "siteName": string,
    "lineNotify": boolean,
    "gateways": Gateway[]
}

function LiffNotification() {
    // const { idToken } = useParams(props.idToken);
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm<LiffSettingDatas>();
    const [isLiffInitialized, setIsLiffInitialized] = useState(false);
    const [gateways, setGateways] = useState<Gateway[]>([]);
    const [siteRecno, setSiteRecno] = useState<number>();
    const [lineNotify, setLineNotify] = useState<boolean>();
    const [siteName, setSiteName] = useState<string>("");
    const [isSetup, setIsSetup] = useState<boolean>(false);
    const [idToken, setIdToken] = useState<any | null>(null);
    const [cookies, setCookie] = useCookies(['authority', 'access_token', 'idToken', 'siteRecno', 'siteId']);
    const env = process.env as unknown as EnvType;
    const liff_id = env.REACT_APP_LIFF_APP_ID_2;

    // LINE通知のトグルボタンのハンドラ
    const handleLineNotificationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLineNotify(event.target.checked);
    }

    const handleSensorNotificationChange = (gatewayRecno:number, sensorRecno: number, event: React.ChangeEvent<HTMLInputElement>) => {
        let newGateways:Gateway[] = gateways.map((gateway) => {
            if(gatewayRecno !== gateway.gatewayRecno){
                return gateway;
            }

            let newGateway:Gateway = gateway;
            let newSensors:Sensor[] = gateway.sensors.map((sensor:Sensor) => {
                if(sensorRecno !== sensor.sensorRecno){
                    return sensor;
                }
                let newSensor: Sensor = sensor;
                newSensor.isNotify = event.target.checked;
                return newSensor;
            });
            newGateway.sensors = newSensors;
            return newGateway;
        });

        setGateways(newGateways);
    }

    // lineの初期化
    useEffect(() => {
        async function initializeLiff() {
            try {
                liff.use(new LIFFInspectorPlugin());
                await liff.init({ liffId: liff_id });
                setIsLiffInitialized(true);
                const lineIdToken: string = liff.getIDToken() ?? "";
                if(lineIdToken == ""){
                    setIsSetup(true);
                }else{
                    setIdToken(lineIdToken);
                    getSetting(lineIdToken);
                }
            } catch (error) {
                console.error('LIFF initialization failed:', error);
                setIsSetup(true);
            }
        }
        initializeLiff();
    }, []);

    // 現場情報取得
    const getSetting = (lineIdToken : string) => {
        axios.post(
            baseUrlLiff + "/getSetting",
            {},
            {
                headers: {
                    'LineToken': `${lineIdToken}`,
                }
            }
        )
            .then(response => {
                const LineSettingArrays = response.data;
                if(response.data.result == -1){
                    setIsSetup(true);
                }else{
                    let gateways = LineSettingArrays.gateways;
                    setGateways(gateways);
                    setSiteRecno(LineSettingArrays.siteRecno);
                    setLineNotify(LineSettingArrays.lineNotify);
                    setSiteName(response.data.siteName);
                    setIsSetup(true);
                }
            })
            .catch(error => {
                console.error("getSettingからのレスポンス取得に失敗:", error);
                setIsSetup(true);
            });
    }

    const onSubmit: SubmitHandler<LiffSettingDatas> = async (data) => {
        try {
            let request = {
                siteRecno: siteRecno,
                lineNotify: lineNotify,
                gateways: gateways,
            };
            const response = await axios.post(
                baseUrlLiff + "/registSetting",
                request,
                {
                    headers: {
                        'LineToken': `${idToken}`,
                    }
                }
            );
            liff.closeWindow();
        } catch (error) {
            console.error("エラーが発生しました", error);
        }
    };
    const handleCancel = () => {
        liff.closeWindow();
    };

    return (
        <div>
            {isSetup ?
                (!idToken || siteName == "") ? (
                    <p>現場情報が取得できません。「サイト表示」から認証を行ってください</p>
                ) : (
                    <div className="liff-wrapper">
                        <header className="liff-header" id="liff-header">
                            <div className="liff-header-name">設定／配信設定</div>
                        </header>
                        <main className="liff-main" id={"sensorList"}>
                            <div className="liff-sec">
                                <div className="liff-sec-name">
                                    SNS通知
                                </div>
                                <div className="liff-action">
                                    <label htmlFor="sw1" className="liff-action-name">
                                        LINE通知
                                    </label>
                                    <input
                                        type="checkbox"
                                        id="sw1"
                                        className="liff-toggle"
                                        checked={lineNotify || false}
                                        onChange={handleLineNotificationChange}
                                    />
                                </div>
                            </div>

                            {gateways.map((gateway) => (
                                gateway.sensors.map((sensor) => (
                                    <div
                                        className="liff-sec"
                                        key={sensor.sensorRecno}
                                    >
                                        <div className="liff-site-name">{siteName}</div>
                                        <div className="liff-gateway-name">{gateway.gatewayControlNo}</div>
                                        <div className="liff-sec-name">{sensor.sensorName}</div>
                                        <div className="liff-action">
                                            <label
                                                htmlFor={`sw-${sensor.sensorRecno}`}
                                                className="liff-action-name"
                                            >
                                                通知
                                            </label>
                                            <input
                                                type="checkbox"
                                                id={`sw-${sensor.sensorRecno}`}
                                                className="liff-toggle"
                                                checked={sensor.isNotify || false}
                                                onChange={
                                                    (e) => {
                                                        handleSensorNotificationChange(gateway.gatewayRecno, sensor.sensorRecno, e)
                                                    }}
                                            />
                                        </div>
                                    </div>
                                ))
                            ))}
                        </main>
                        <footer className="liff-footer" id="liff-footer">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <button type="button" className="btn-cancel" id={"cancelBtn"} onClick={handleCancel}>キャンセル</button>
                                <button type="submit" className="btn btn-ok" id={"applyBtn"}>適用</button>
                            </form>
                        </footer>
                    </div>
                )
                : <></>}
        </div>
    );
}

export default LiffNotification;
